import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const PlanInfo = ({ showModel = false, adviceResponse = null }) => {
  const { plan, isAuthenticated } = useAuth();

  const planConfig = {
    free: {
      name: '無料',
      color: 'bg-gray-100 text-gray-800',
      model: 'GPT-4o Mini',
      limit: '月3回',
      features: ['基本アドバイス', '広告表示']
    },
    standard: {
      name: 'スタンダード',
      color: 'bg-green-100 text-green-800',
      model: 'GPT-4o Mini',
      limit: '月30回',
      features: ['詳細アドバイス', '広告なし']
    },
    premium: {
      name: 'プレミアム',
      color: 'bg-purple-100 text-purple-800',
      model: 'o4-mini',
      limit: '無制限',
      features: ['スムーズ応答（高速版）', '広告なし', '画像アップロード（近日公開）']
    }
  };

  const currentPlan = planConfig[plan] || planConfig.free;
  const modelUsed = adviceResponse?.model || currentPlan.model;

  if (!showModel && !isAuthenticated && plan === 'free') {
    return null; // Don't show plan info for anonymous users unless specifically requested
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${currentPlan.color}`}>
            {currentPlan.name}プラン
          </span>
          {showModel && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {modelUsed}
            </span>
          )}
        </div>
        
        {isAuthenticated && (
          <div className="text-sm text-gray-600">
            {currentPlan.limit}
          </div>
        )}
      </div>
      
      {showModel && (
        <div className="mt-3">
          <div className="text-sm text-gray-600 mb-2">プラン機能:</div>
          <ul className="text-sm text-gray-500 space-y-1">
            {currentPlan.features.map((feature, index) => (
              <li key={index} className="flex items-center">
                <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      )}
      
      {!isAuthenticated && plan === 'free' && showModel && (
        <div className="mt-3 p-3 bg-blue-50 rounded-md">
          <div className="text-sm text-blue-700">
            📝 <strong>さらに機能を活用したい方へ</strong> アカウント作成で月30回の相談と上位プランにアクセス！
          </div>
        </div>
      )}
      
      {isAuthenticated && plan === 'free' && showModel && (
        <div className="mt-3 p-3 bg-purple-50 rounded-md">
          <div className="text-sm text-purple-700">
            ⭐ <strong>プレミアムプランにアップグレード</strong> で無制限相談とスムーズ応答で、待ち時間なく相談できます
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanInfo;